import React from 'react';
import {Box, Typography} from '@mui/material';

/**
 * Shared page shell for every Individual Dashboard section.
 * Renders the page header (title + subtitle), optional tabs, and {children}.
 */
const IndividualDashboardShell = ({tabs, children}) => {
    return (
        <Box>
            <Box sx={{
                display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between',
                mb: 2, pb: 2.5, borderBottom: '1px solid #E5E7EB', flexWrap: 'wrap', gap: 2,
            }}>
                <Box>
                    <Typography sx={{fontSize: {xs: '20px', md: '26px'}, fontWeight: 800, color: '#052F44', lineHeight: 1.2}}>
                        Individual Dashboard
                    </Typography>
                    <Typography sx={{fontSize: '14px', color: '#6A7282', mt: 0.5}}>
                        A personal summary of your online skills, strengths and next steps
                    </Typography>
                </Box>
            </Box>

            {/* Persistent Tabs Navigation - rendered above content */}
            {tabs}

            {/* Section content rendered unconditionally so child pages/tabs run their own lifecycle */}
            {children}
        </Box>
    );
};

export default IndividualDashboardShell;
